@if (preLabel) {
    @if (preLabelClickCallback) {
        <button
            [wdxButton]="WdxButtonStyle.Link"
            [wdxButtonSize]="WdxButtonSize.Sm"
            (click)="preLabelClickCallback()"
            data-cy="badge-renderer-prelabel-callback"
            wdxStopPropagation
        >
            {{ preLabel | translateTokenisedString }}
        </button>
    } @else if (preLabelUrl) {
        <a [routerLink]="preLabelUrl" data-cy="badge-renderer-prelabel-link">{{
            preLabel | translateTokenisedString
        }}</a>
    } @else {
        <span data-cy="badge-renderer-prelabel">
            {{ preLabel | translateTokenisedString }}
        </span>
    }
}
@if (!disableBadge) {
    <div [ngClass]="badgeClasses" class="px-2" data-cy="badge-renderer-badge">
        {{ label }}
    </div>
}
@if (postLabel) {
    @if (postLabelClickCallback) {
        <button
            [wdxButton]="WdxButtonStyle.Link"
            [wdxButtonSize]="WdxButtonSize.Sm"
            (click)="postLabelClickCallback()"
            data-cy="badge-renderer-postlabel-callback"
            wdxStopPropagation
        >
            {{ preLabel | translateTokenisedString }}
        </button>
    } @else if (postLabelUrl) {
        <a
            [routerLink]="postLabelUrl"
            data-cy="badge-renderer-postlabel-link"
            >{{ preLabel | translateTokenisedString }}</a
        >
    } @else {
        <span data-cy="badge-renderer-postlabel">
            {{ postLabel | translateTokenisedString }}
        </span>
    }
}
